import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import i18n from "../../../locale/i18n";
import ErrorBox from "../components/ErrorBox/ErrorBox";
import routes from "../routes";
import {Icon, Card, List} from "semantic-ui-react";
import {NavLink} from "react-router-dom";
import {AnalyticsTracking} from "../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

class HomeView extends React.Component<RouteComponentProps<{}>, {}> {

    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.state = {};

    }

    componentDidMount() {
        ErrorBox.reset();
    }

    renderTiles() {
        return routes.filter(route => !route.hideInNav && route.path !== '/')
                     .filter(route => !route.guard || route.guard())
                     .map((route) =>
                (!route.requiredRole) && [
                    <Card as={NavLink} to={route.path} exact={!!route.exact} key={route.path}>
                        <Card.Content style={{textAlign: 'center'}}>
                            <Icon name={route.icon} style={{size: '2em'}}/><br />
                            {t("Route." + route.title)}
                        </Card.Content>
                    </Card>
                ]
            );
    }

    render() {
        return (
            <>
              <AnalyticsTracking page="home" />
              <div className={"ui container"} style={{marginBottom: '2.5em'}}>
                <h1>{t("Home.Heading")}</h1>
                <p>{t("Home.Text")}</p>
              </div>
              <div className={"ui container"}>
                <Card.Group stackable={true}>
                  {this.renderTiles()}
                </Card.Group>
              </div>
              <div className={"ui container"}>
                <br/><br/>
              </div>
              <div className={"ui container"}>
                <h2>{t("Home.AboutLandgard")}</h2>
                <List>
                  <List.Item><a href={t("Links.LandgardHome.url")} target="_blank" rel="noopener noreferrer">{t("Links.LandgardHome.text")}</a></List.Item>
                  <List.Item><a href={t("Links.Imprint.url")} target="_blank" rel="noopener noreferrer">{t("Links.Imprint.text")}</a></List.Item>
                  <List.Item><a href={t("Links.Privacy.url")} target="_blank" rel="noopener noreferrer">{t("Links.Privacy.text")}</a></List.Item>
                </List>
              </div>
              <div className={"ui container"}>
                <br/><br/>
                <br/><br/>
              </div>
            </>
        );

    }
}

export default HomeView;